export const mapStatusFilter = statusId => {
  const state =
    {
      0: "Todos",
      2: "A confirmar",
      9: "Confirmado",
      4: "Recusado",
      8: "Cancelado",
      5: "Não trouxe"
    }[statusId] || null;
  return state;
};
